import { createRequestTypes, action } from '../utils/actions';
import { REQUEST, SUCCESS, FAILURE } from '../utils/constants';

export const GET_BLACKLIST_ENTRIES = createRequestTypes('GET_BLACKLIST_ENTRIES');
export const GET_BLACKLIST_POWERBOX = createRequestTypes('GET_BLACKLIST_POWERBOX');
export const GET_BLACKLIST_LICENSE = createRequestTypes('GET_BLACKLIST_LICENSE');
export const GET_BLACKLIST_ENTRY = createRequestTypes('GET_BLACKLIST_ENTRY');
export const MOVE_TO_BLACKLIST = createRequestTypes('MOVE_TO_BLACKLIST');
export const DELETE_FROM_BLACKLIST = createRequestTypes('DELETE_FROM_BLACKLIST');
export const SET_LICENSE_BLACKLIST_TABLE_SORTING = 'SET_LICENSE_BLACKLIST_TABLE_SORTING';
export const SET_POWERBOX_BLACKLIST_TABLE_SORTING = 'SET_POWERBOX_BLACKLIST_TABLE_SORTING';
export const SET_POWERBOX_BLACKLIST_TABLE_FILTER = 'SET_POWERBOX_BLACKLIST_TABLE_FILTER';
export const SET_LICENSE_BLACKLIST_TABLE_FILTER = 'SET_LICENSE_BLACKLIST_TABLE_FILTER';

export const getBlacklistEntries = {
  request: (data) => action(GET_BLACKLIST_ENTRIES[REQUEST], { data }),
  success: (payload) => action(GET_BLACKLIST_ENTRIES[SUCCESS], { payload }),
  failure: (payload) => action(GET_BLACKLIST_ENTRIES[FAILURE], { payload }),
};

export const getBlacklistPowerbox = {
  request: (data) => action(GET_BLACKLIST_POWERBOX[REQUEST], { data }),
  success: (payload) => action(GET_BLACKLIST_POWERBOX[SUCCESS], { payload }),
  failure: (payload) => action(GET_BLACKLIST_POWERBOX[FAILURE], { payload }),
};

export const getBlacklistLicense = {
  request: (data) => action(GET_BLACKLIST_LICENSE[REQUEST], { data }),
  success: (payload) => action(GET_BLACKLIST_LICENSE[SUCCESS], { payload }),
  failure: (payload) => action(GET_BLACKLIST_LICENSE[FAILURE], { payload }),
};

export const getBlacklistEntry = {
  request: (id) => action(GET_BLACKLIST_ENTRY[REQUEST], { id }),
  success: (payload) => action(GET_BLACKLIST_ENTRY[SUCCESS], { payload }),
  failure: (payload) => action(GET_BLACKLIST_ENTRY[FAILURE], { payload }),
};

export const moveToBlacklist = {
  request: (data) => action(MOVE_TO_BLACKLIST[REQUEST], { data }),
  success: (payload) => action(MOVE_TO_BLACKLIST[SUCCESS], { payload }),
  failure: (payload) => action(MOVE_TO_BLACKLIST[FAILURE], { payload }),
};

export const deleteFromBlacklist = {
  request: (id) => action(DELETE_FROM_BLACKLIST[REQUEST], { id }),
  success: (payload) => action(DELETE_FROM_BLACKLIST[SUCCESS], { payload }),
  failure: (payload) => action(DELETE_FROM_BLACKLIST[FAILURE], { payload }),
};

export const setLicenseBlacklistTableFilter = (payload) => ({
  type: SET_LICENSE_BLACKLIST_TABLE_FILTER,
  payload,
});

export const setLicenseBlacklistTableSorting = (payload) => ({
  type: SET_LICENSE_BLACKLIST_TABLE_SORTING,
  payload,
});

export const setPowerboxBlacklistTableFilter = (payload) => ({
  type: SET_POWERBOX_BLACKLIST_TABLE_FILTER,
  payload,
});

export const setPowerboxBlacklistTableSorting = (payload) => ({
  type: SET_POWERBOX_BLACKLIST_TABLE_SORTING,
  payload,
});
